import React from 'react';
import github from '../../images/github.png';
import linkedin from '../../images/linkedin.png';

function Contact() {
  return (
    <div id="contactSection" className="contact">
      <h1 className="contact-heading">Let's get in touch.</h1>
      <div>
        <a href='https://github.com/Swapnil-2001'>
          <img src={github} alt="github" className="contact-img" />
        </a>
        <a href='https://www.linkedin.com/in/swapnil-sengupta-110498198/'>
          <img src={linkedin} alt="linkedin" className="contact-img" style={{ marginLeft: '10px' }} />
        </a>
      </div>
    </div>
  )
}

export default Contact;